import React from 'react';

import type { Transaction } from 'types/api/transaction';

import type { StatusTagType } from './StatusTag';
import StatusTag from './StatusTag';

export interface Props {
  status: Transaction['status'];
  errorText?: string | null;
  isLoading?: boolean;
}

const TxStatus = ({ status, errorText, isLoading }: Props) => {
  if (status === undefined) {
    return null;
  }

  let text;
  let type: StatusTagType;
  let bg;

  switch (status) {
    case 'ok':
      text = 'Success';
      type = 'ok';
      bg = 'green.700';
      break;
    case 'error':
      text = 'Failed';
      type = 'error';
      bg = 'red.600';
      break;
    case null:
      text = 'Pending';
      type = 'pending';
      bg = 'yellow.700';
      break;
  }

  return <StatusTag type={ type } text={ text } errorText={ errorText } bg={bg} loading={ isLoading }/>;
};

export default TxStatus;
